import React, { useState } from 'react';
import { PlayIcon, XIcon } from 'lucide-react';
interface BrandVideosProps {
  brandSlug: string;
}
export function BrandVideos({
  brandSlug
}: BrandVideosProps) {
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
  const videos = [{
    id: 1,
    title: 'Brand Story',
    thumbnail: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=600',
    duration: '2:45',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
  }, {
    id: 2,
    title: 'Product Innovation',
    thumbnail: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=600',
    duration: '3:20',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
  }, {
    id: 3,
    title: 'Behind the Scenes',
    thumbnail: 'https://images.unsplash.com/photo-1471864190281-a93a3070b6de?w=600',
    duration: '4:15',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
  }];
  return <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1393" data-mp="3jio21p3hnp4b">
      <div className="flex items-center justify-between mb-6" data-id="element-1394" data-mp="3jh3923wtoe8k">
        <div data-id="element-1395" data-mp="3ele4tn9uy95x">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-1396" data-mp="3elnx5hidkses">
            Brand Videos
          </h2>
          <p className="text-gray-600" data-id="element-1397" data-mp="3scsrq56vyui9">Discover our story and innovation</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1398" data-mp="3niog38modyau">
        {videos.map(video => <div key={video.id} onClick={() => setSelectedVideo(video.videoUrl)} className="relative rounded-xl overflow-hidden shadow-lg cursor-pointer group" data-id="element-1399" data-mp="62gffxr49drv">
            <div className="relative aspect-video" data-id="element-1400" data-mp="f2v8xke8hz6g">
              <img src={video.thumbnail} alt={video.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" data-id="element-1401" data-mp="b4fh9377k2mp" />
              <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-50 transition-all flex items-center justify-center" data-id="element-1402" data-mp="2cwbqu79tf2eu">
                <div className="bg-white bg-opacity-90 rounded-full p-4 group-hover:scale-110 transition-transform" data-id="element-1403" data-mp="kt7n72vp29oj">
                  <PlayIcon className="w-8 h-8 text-[#1E2B55]" data-id="element-1404" data-mp="prrdffhbm7mp" />
                </div>
              </div>
              <div className="absolute bottom-3 right-3 bg-black bg-opacity-70 text-white text-sm px-2 py-1 rounded" data-id="element-1405" data-mp="urni7gxue33b">
                {video.duration}
              </div>
            </div>
            <div className="bg-white p-4" data-id="element-1406" data-mp="13rjzuylte1ov">
              <h3 className="font-bold text-gray-900" data-id="element-1407" data-mp="13qhbaxbysbc4">{video.title}</h3>
            </div>
          </div>)}
      </div>
      {/* Video Modal */}
      {selectedVideo && <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4" data-id="element-1408" data-mp="1dgtt4hse9qek">
          <div className="relative w-full max-w-4xl" data-id="element-1409" data-mp="1ii9d06iu5qvd">
            <button onClick={() => setSelectedVideo(null)} className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors" data-id="element-1410" data-mp="1mia4arr19wju">
              <XIcon className="w-8 h-8" data-id="element-1411" data-mp="36y9cdl53nhuj" />
            </button>
            <div className="aspect-video bg-black rounded-lg overflow-hidden" data-id="element-1412" data-mp="32xfm4l46pqyh">
              <iframe src={selectedVideo} className="w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-1413" data-mp="2y0yw1ldfd2ir"></iframe>
            </div>
          </div>
        </div>}
    </div>;
}